import { Component } from '@angular/core';
import { ConfigService } from 'app/_services/config.service';

@Component({
    selector: 'app-calendar-widget',
    template: `
        <legislation-form id="legislation-form" api="{{apiUrl}}" sending-disabled="true">
            <span slot="recaptcha-slot">
                <recaptcha-element id="recaptchaElement" api="{{apiUrl}}"></recaptcha-element>
            </span>
        </legislation-form>
    `,
})
export class LegislativeFormWidgetComponent {
    apiUrl = '';

    constructor(private configService: ConfigService) {
        this.apiUrl = this.configService.hostAddress;
    }
}
